"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _fontColorMixin = require("../fontColorMixin");
var _inlineMediaQueryMixin = require("../inlineMediaQueryMixin");
var _mediaQueryMixin = require("../mediaQueryMixin");
var _spacingMixin = require("../spacingMixin");
var sizeCSS = (0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('size', function (mediaProps) {
  return (0, _styledToken.default)('icons.sizes', function (iconSizes) {
    var size = mediaProps.size;
    if (iconSizes && iconSizes[size]) {
      var iconSize = iconSizes[size] + "px";
      return "\n                height: " + iconSize + ";\n                width: " + iconSize + ";\n            ";
    }
    return '';
  })(mediaProps);
});

/** @class IconMixin */
/** @method */
var IconMixin = function IconMixin(props) {
  return (0, _styledComponents.css)(["display:inline-block;vertical-align:top;stroke:currentColor;fill:currentColor;", " ", " height:1em;width:1em;", " ", ""], (0, _fontColorMixin.fontColorMixin)(props), (0, _spacingMixin.spacingMixin)(props), sizeCSS(props), (0, _mediaQueryMixin.mediaQueryMixin)(function (mediaProps) {
    return sizeCSS(Object.assign({}, props, mediaProps));
  }));
};
exports.IconMixin = IconMixin;